lineOffset